import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, IModalProps, PrimaryButton } from "@fluentui/react";
import { RootState } from "app/store";
import { createTierLevels } from "global/Application";
import { useState } from "react";
import { useSelector } from "react-redux";
import TierWizard, { ITierChange } from "views/TierWizard";

interface IProps {
    hidden?: boolean;
    onDismiss?: () => void;
    onChange?: (tier: ITierChange | undefined) => void;
}

// TODO move this to a more global location
export const TiersByName = {
    "Comprehensive": {
        "bcbs_config_tiersetid": "76291671-4f49-ec11-8c62-000d3a591604",
    },
    "EPO": {
        "bcbs_config_tiersetid": "361d38d1-4f49-ec11-8c62-000d3a591604",
    },
    "PPO with HSA": {
        "bcbs_config_tiersetid": "516166fb-4f49-ec11-8c62-000d3a591604",
    },
    "Standard PPO": {
        "bcbs_config_tiersetid": "6b78a43e-5049-ec11-8c62-000d3a591604",
    },
    "3 Tier EPO": {
        "bcbs_config_tiersetid": "0fd9cd68-5049-ec11-8c62-000d3a591604",
    },
    "3 Tier PPO": {
        "bcbs_config_tiersetid": "f31e9e93-5049-ec11-8c62-000d3a591604",
    },
    "4 Tier": {
        "bcbs_config_tiersetid": "809bc6be-5049-ec11-8c62-000d3a591604",
    },
    "5 Tier": {
        "bcbs_config_tiersetid": "1b797fef-5049-ec11-8c62-000d3a591604",
    },
    "6 Tier": {
        "bcbs_config_tiersetid": "b8f3d261-5149-ec11-8c62-000d3a591604",
    }
};

const OptionWizard: React.FunctionComponent<IProps> = (props) => {

    const state = useSelector((state: RootState) => state)

    const dialogContentProps: IDialogContentProps = {
        type: DialogType.largeHeader,
        title: 'New Option Wizard',
        subText: undefined,
    };

    const modelProps: IModalProps = {
        isBlocking: false,
        styles: {
            main: {
                minWidth: 850,
            }
        },
    };

    const tierGen = createTierLevels(state.data.config, TiersByName["Standard PPO"].bcbs_config_tiersetid)

    const [tierChange, setTierChange] = useState<ITierChange | undefined>(undefined);

    return <Dialog
        hidden={props.hidden}
        onDismiss={props.onDismiss}
        dialogContentProps={dialogContentProps}
        modalProps={modelProps}
        minWidth={850}
    >
        <div>
            <TierWizard
                variant={'new-opportunity-option'}
                emitOnChangeForDefault={true}
                defaultValue={{
                    tiers: tierGen.tiers,
                    tierSet: tierGen.tierSet,
                }}
                onChange={(value) => {
                    setTierChange(value);
                }}
            />
        </div>
        <DialogFooter>
            <PrimaryButton
                disabled={tierChange?.tiers?.some(t => !t.name) ?? true}
                onClick={() => props.onChange?.(tierChange)}
                text="Continue"
            />
            <DefaultButton onClick={props.onDismiss} text="Cancel" />
        </DialogFooter>
    </Dialog>
}

export default OptionWizard;